import React from 'react'
import { baseUrl } from '@fs/zion-config'
import { getCustomImage } from '../helpers'
import StructuredData from './StructuredData'
import { getOrganizationData } from './OrganizationStructuredData'
import { getOfferData } from './OfferStructuredData'
import { getPersonData } from './PersonStructuredData'
import { stripHtml } from '../../api'
import { getWebSiteData } from './WebSiteStructuredData'

/**
 * We have to have this here to avoid a circular dependency.
 */
const getWebPageData = ({
  data,
  locale,
  mainEntity,
  type = 'WebPage',
  primaryImageOfPage,
  hasPart,
  contentLocation,
}) => {
  const currentPath = window.location.pathname
  const url = data.url || `${baseUrl}${currentPath}`
  return {
    '@type': type,
    '@id': `${url}#webpage`,
    url,
    name: data.name,
    description: stripHtml(data.description) || undefined,
    inLanguage: data.contentLocale?.split('-')[0] || locale || undefined,
    isPartOf: currentPath.endsWith('/rootstech/') ? undefined : getWebSiteData(locale, false),
    hasPart: hasPart || undefined,
    mainEntity,
    primaryImageOfPage,
    contentLocation,
  }
}

export const getExhibitorListItemData = (data, position = 1) => {
  return {
    '@type': 'ListItem',
    position,
    name: data.name,
    description: stripHtml(data.companyDescription),
    url: data.url,
    image: getCustomImage(data),
    item: getOrganizationData(data),
    inLanguage: data.contentLocale?.split('-')[0] || undefined,
  }
}

export const getSpeakerListItemData = (data, position = 1) => {
  return {
    '@type': 'ListItem',
    position,
    name: data.name,
    description: stripHtml(data.biography),
    url: data.url,
    image: getCustomImage(data),
    item: getPersonData(data),
    inLanguage: data.contentLocale?.split('-')[0] || undefined,
  }
}

export const getPageListItemData = (data, position = 1) => {
  return {
    '@type': 'ListItem',
    position,
    name: data.name || data.title,
    description: stripHtml(data.description),
    url: data.url,
    image: getCustomImage(data),
    item: getWebPageData({ data }),
    inLanguage: data.contentLocale?.split('-')[0] || undefined,
  }
}

export const getPromotionListItemData = (data, position = 1) => {
  const { item } = data
  const { title, url, sessionUrl } = item ?? data
  const actualUrl = url ?? sessionUrl
  const image = getCustomImage(item ?? data)

  return {
    '@type': 'ListItem',
    position,
    name: title,
    url: actualUrl,
    image,
    item: getOfferData(data),
  }
}

export const getListItemData = (data, position) => {
  const { item } = data
  const { title, url, sessionUrl } = item ?? data
  const actualUrl = url ?? sessionUrl
  const image = getCustomImage(item ?? data)

  return {
    '@type': 'ListItem',
    position,
    name: title,
    url: actualUrl,
    image,
  }
}

export default function ListItemStructuredData({ data }) {
  if (!data) return null
  const structuredData = getListItemData(data)

  return <StructuredData data={structuredData} dataTestId="carousel-structured-data" />
}
